import React, { useCallback } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import type { FC, ChangeEvent } from "react";
import { useStyles } from "./FormatControl.styles";
import { BulkExportFormat } from "../../../../../../types";
import type { IFormatControlProps } from "./FormatControl.types";

export const FormatControl: FC<IFormatControlProps> = (props) => {
  const classes = useStyles();
  const { value, onChange } = props;

  const handleChange = useCallback(
    (e: ChangeEvent<{}>, value: string) => {
      onChange?.(value as BulkExportFormat);
    },
    [onChange, value]
  );

  return (
    <FormControl component="fieldset" className={classes.root}>
      <FormLabel component="legend" className={classes.label}>
        File format
      </FormLabel>
      <RadioGroup className={classes.group} row aria-label="position" name="position" value={value} onChange={handleChange}>
        <FormControlLabel
          className={classes.controlLabel}
          value={BulkExportFormat.XLSX}
          control={<Radio color="primary" className={classes.control} />}
          label="XLSX"
        />
        <FormControlLabel
          className={classes.controlLabel}
          value={BulkExportFormat.CSV}
          control={<Radio color="primary" className={classes.control} />}
          label="CSV"
        />
      </RadioGroup>
    </FormControl>
  );
};
